export default {"src":"/_next/static/media/inventoryCheck.14dbf7ac.svg","height":51,"width":41,"blurWidth":0,"blurHeight":0};